import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { getRecentSearches, LSRecentSearchesFieldName } from '../search-bar/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import img from '../../../../assets/images/search.svg.js';
import css_248z$1 from '../../atoms/buttons/generic-button/styles/secondary-button.scss.js';
import css_248z from './pcm-search.scss.js';

class PcmSearch extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.searchTerm = '';
        this.buttonDisabled = true;
        this.inputEl = null;
        this.inputWrapper = null;
        this.recentSearches = [];
        this.onSearchTermChange = (e) => {
            if (e.target.value === '') {
                this.buttonDisabled = true;
                this.renderRoot.querySelector('form').classList.add('empty');
            }
            else {
                this.buttonDisabled = false;
                this.renderRoot.querySelector('form').classList.remove('empty');
            }
        };
        this.onKeyDown = (e) => {
            // only e.keyCode works on android 'Go' key
            const isEnterKey = e.code === 'Enter' || e.keyCode === 13;
            if (!isEnterKey)
                return;
            e.preventDefault();
            if (!this.buttonDisabled)
                this.submitForm();
        };
    }
    doSearch() {
        var _a, _b;
        if (this.inputEl.value.length !== undefined ||
            this.inputEl.value.length == null ||
            this.inputEl.value.length > 0) {
            document.location.href = this.searchPageUrl + '/?s=' + encodeURIComponent((_b = (_a = this.inputEl) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "");
        }
        else {
            this.handleFocus();
        }
    }
    submitForm() {
        this.doSearch();
    }
    handleFocus() {
        var _a;
        (_a = this.inputWrapper) === null || _a === void 0 ? void 0 : _a.classList.add('focus');
    }
    handleBlur() {
        var _a;
        (_a = this.inputWrapper) === null || _a === void 0 ? void 0 : _a.classList.remove('focus');
    }
    firstUpdated() {
        this.inputEl = this.renderRoot.querySelector('input[name="q"]');
        this.inputWrapper = this.renderRoot.querySelector('.input-wrapper');
        this.inputEl.value = this.searchTerm;
        this.inputEl.dispatchEvent(new Event('keyup'));
        this.recentSearches = getRecentSearches(LSRecentSearchesFieldName);
    }
    render() {
        return x `<form class="form ${this.rtl || isRTL() ? 'rtl' : ''}" action="${this.searchPageUrl}"><p class="search-title">${this.searchTitle}</p><div style="display:flex;justify-content:space-evenly"><div class="input-wrapper"><input class="search-input" type="text" name="q" aria-label="${this.searchTitle}" @keyup="${this.onSearchTermChange}" @input="${this.onSearchTermChange}" @focus="${this.handleFocus}" @blur="${this.handleBlur}" @keydown="${this.onKeyDown}" placeholder="${this.searchPlaceholder}"><icon-button basic class="submit ${this.buttonDisabled ? 'disabled' : ''}" styleType="${ButtonStyleTypes.OUTLINED_DARK}" @click="${this.submitForm}" ?disabled="${this.buttonDisabled}" ariaLabel="${this.searchButtonText}"><img slot="icon" src="${img}" alt="" aria-hidden="true"></icon-button></div><load-more-button text="Search" style="margin-left:1em" @click="${this.submitForm}"></load-more-button></div></form>`;
    }
}
PcmSearch.styles = [css_248z, css_248z$1];
__decorate([
    n({ type: Boolean })
], PcmSearch.prototype, "rtl", void 0);
__decorate([
    n({ type: String })
], PcmSearch.prototype, "searchPageUrl", void 0);
__decorate([
    n({ type: String })
], PcmSearch.prototype, "searchTitle", void 0);
__decorate([
    n({ type: String })
], PcmSearch.prototype, "searchPlaceholder", void 0);
__decorate([
    n({ type: String })
], PcmSearch.prototype, "searchButtonText", void 0);
__decorate([
    n({ type: String })
], PcmSearch.prototype, "searchTerm", void 0);
__decorate([
    t()
], PcmSearch.prototype, "buttonDisabled", void 0);
customElements.define('pcm-search', PcmSearch);

export { PcmSearch };
